import type { ImportRow, Student } from "./types";

export function toScore(value: unknown): number | null {
  const text = String(value ?? "").trim();
  if (!text) return null;
  const parsed = Number(text.replace(",", "."));
  return Number.isFinite(parsed) ? parsed : Number.NaN;
}

export function parseScoreColumn(text: string, students: Student[], startStudentCode: string): { rows: ImportRow[]; error: string } {
  if (!text.trim()) return { rows: [], error: "" };
  if (text.includes("\t")) return { rows: [], error: "Chỉ dán một cột điểm. Hãy chọn đúng một cột trong Excel." };
  const values = text.replace(/\r\n?/g, "\n").split("\n");
  while (values.length && values[values.length - 1] === "") values.pop();
  if (values.length > 2_000) return { rows: [], error: "Dữ liệu vượt quá giới hạn 2.000 học sinh." };
  const startIndex = students.findIndex((student) => student.studentCode === startStudentCode);
  if (startIndex < 0) return { rows: [], error: "Hãy chọn học sinh bắt đầu trong danh sách đang hiển thị." };
  if (values.length > students.length - startIndex) return { rows: [], error: `Có ${values.length} dòng điểm nhưng chỉ còn ${students.length - startIndex} học sinh từ dòng bắt đầu. Hãy kiểm tra thứ tự hoặc chọn dòng bắt đầu khác.` };
  return {
    rows: values.map((value, index) => ({
      studentCode: students[startIndex + index].studentCode,
      lastName: students[startIndex + index].lastName,
      firstName: students[startIndex + index].firstName,
      value: toScore(value),
    })),
    error: "",
  };
}
